import { render, staticRenderFns } from "./r-select.vue?vue&type=template&id=8545430c&scoped=true"
import script from "./r-select.vue?vue&type=script&lang=js"
export * from "./r-select.vue?vue&type=script&lang=js"
import style0 from "./r-select.vue?vue&type=style&index=0&id=8545430c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8545430c",
  null
  
)

export default component.exports